import i18n from '@/i18n'
import Store from '@/store'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFontsBn from 'pdfmake/build/vfs_fonts_bn'
import pdfFontsEn from 'pdfmake/build/vfs_fonts_en'
function getBase64ImageFromURL (url) {
  return new Promise((resolve, reject) => {
    var img = new Image()
    img.setAttribute('crossOrigin', 'anonymous')
    img.onload = () => {
      var canvas = document.createElement('canvas')
      canvas.width = img.width
      canvas.height = img.height
      var ctx = canvas.getContext('2d')
      ctx.drawImage(img, 0, 0)
      var dataURL = canvas.toDataURL('image/png')
      resolve(dataURL)
    }
    img.onerror = error => {
      reject(error)
    }
    img.src = url
  })
}
const exportPdfDetails = async (reportTitle, data, vm, awarenessEventServiceBaseUrl) => {
    try {
      Store.commit('mutateCommonProperties', {
        loading: true
      })
      if (i18n.locale === 'bn') {
        pdfMake.vfs = pdfFontsBn.pdfMake.vfs
      } else {
          pdfMake.vfs = pdfFontsEn.pdfMake.vfs
      }
        const pdfContent = []
        pdfContent.push(
          { text: data.personal.name, style: 'mainName', alignment: 'left' },
          { text: vm.$t('externalUser.mobile_no') + '           :       ' + data.personal.mobile, style: 'address', alignment: 'left' },
          { text: vm.$t('externalUser.email') + '                 :       ' + 'email', style: 'address', alignment: 'left' }
        )
        if (data.personal.photo) {
          pdfContent.push(
            { image: await getBase64ImageFromURL(awarenessEventServiceBaseUrl + 'download-attachment?file=app/public' + data.personal.photo), width: 100, height: 100, style: 'search', rowSpan: 5, absolutePosition: { x: 670, y: 50 } }
          )
        } else {
          pdfContent.push(
            { image: await getBase64ImageFromURL(awarenessEventServiceBaseUrl + 'download-attachment?file=app/public/no-image.jpg'), width: 100, height: 100, style: 'search', rowSpan: 5, absolutePosition: { x: 670, y: 50 } }
          )
        }
        pdfContent.push(
          {
            style: 'tableExample',
            table: {
              body: [
                [{ text: vm.$t('externalUser.personal_information'), style: 'tableHeader', fillColor: '#dddddd', decoration: 'underline' }, { text: ':', fillColor: '#dddddd' }]
              ]
            },
            layout: 'noBorders'
          }
        )
        pdfContent.push(
          { text: vm.$t('externalUser.father_name') + '           :       ' + data.personal.father_name, style: 'address', alignment: 'left' },
          { },
          { text: vm.$t('externalUser.mother_name') + '           :       ' + data.personal.mother_name, style: 'address', alignment: 'left' },
          { },
          { text: vm.$t('retailerManagement.nid') + '             :       ' + data.personal.nid, style: 'address', alignment: 'left' },
          { },
          { text: vm.$t('production_service_config.reg_date') + '    :       ' + data.personal.registration_date, style: 'address', alignment: 'left' },
          { }
        )
        pdfContent.push(
          {
            style: 'tableExample',
            table: {
              body: [
                [{ text: vm.$t('externalUser.employment_history'), style: 'tableHeader', fillColor: '#dddddd', decoration: 'underline' }, { text: ':', fillColor: '#dddddd' }]
              ]
            },
            layout: 'noBorders'
          }
        )
        const topRowsData = [
          [
            { text: vm.$t('externalUser.company_name'), bold: true, style: 'td' },
            { text: vm.$t('externalUser.company_business'), bold: true, style: 'td' },
            { text: vm.$t('externalUser.designation'), bold: true, style: 'td' },
            { text: vm.$t('externalUser.department'), bold: true, style: 'td' },
            { text: vm.$t('externalUser.start_date'), bold: true, style: 'td' },
            { text: vm.$t('externalUser.end_date'), bold: true, style: 'td' },
            { text: vm.$t('externalUser.responsibilities'), bold: true, style: 'td' },
            { text: vm.$t('externalUser.company_location'), bold: true, style: 'td' },
            { text: vm.$t('externalUser.skill_info'), bold: true, style: 'td' }
          ]
        ]
        data.job.map((item, index) => {
          topRowsData.push([
            { text: item.lang === 'bn' ? item.company_name_bn : item.company_name_en, style: 'td' },
            { text: item.lang === 'bn' ? item.company_business_bn : item.company_business_en, style: 'td' },
            { text: item.lang === 'bn' ? item.designation_bn : item.designation_en, style: 'td' },
            { text: item.lang === 'bn' ? item.department_bn : item.department_en, style: 'td' },
            { text: item.start_date, bold: true, style: 'td' },
            { text: item.end_date, bold: true, style: 'td' },
            { text: item.lang === 'bn' ? item.responsibilities_bn : item.responsibilities_en, style: 'td' },
            { text: item.lang === 'bn' ? item.company_location_bn : item.company_location_en, style: 'td' },
            { text: item.skill, style: 'td' }
          ])
        })
        pdfContent.push({
          table: {
            headerRows: 1,
            widths: ['*', '*', '*', '*', '*', '*', '*', '*', '*'],
            body: topRowsData
          }
        })
        pdfContent.push(
          {
            style: 'tableExample',
            table: {
              body: [
                [{ text: vm.$t('externalUser.academic_qualification'), style: 'tableHeader', fillColor: '#dddddd', decoration: 'underline' }, { text: ':', fillColor: '#dddddd' }]
              ]
            },
            layout: 'noBorders'
          }
        )
        const topRowsDataTwo = [
          [
            { text: vm.$t('externalUser.level_of_education'), bold: true, style: 'tdtwo' },
            { text: vm.$t('externalUser.degree_title'), bold: true, style: 'tdtwo' },
            { text: vm.$t('externalUser.group'), bold: true, style: 'tdtwo' },
            { text: vm.$t('externalUser.board'), bold: true, style: 'tdtwo' },
            { text: vm.$t('externalUser.institute_name'), bold: true, style: 'tdtwo' },
            { text: vm.$t('externalUser.result'), bold: true, style: 'tdtwo' },
            { text: vm.$t('externalUser.cgpa'), bold: true, style: 'tdtwo' },
            { text: vm.$t('externalUser.scale'), bold: true, style: 'tdtwo' },
            { text: vm.$t('externalUser.year_of_passing'), bold: true, style: 'tdtwo' },
            { text: vm.$t('externalUser.duration'), bold: true, style: 'tdtwo' },
            { text: vm.$t('externalUser.achievement'), bold: true, style: 'tdtwo' }
          ]
        ]
        data.educational.map((item, index) => {
          topRowsDataTwo.push([
              { text: item.educationName, style: 'tdtwo' },
              { text: item.lang === 'bn' ? item.degree_title_bn : item.degree_title_en, style: 'tdtwo' },
              { text: item.lang === 'bn' ? item.group_name_bn : item.group_name_en, style: 'tdtwo' },
              { text: item.board, style: 'tdtwo' },
              { text: item.lang === 'bn' ? item.institute_name_bn : item.institute_name_en, style: 'tdtwo' },
              { text: item.result, style: 'tdtwo' },
              { text: item.cgpa, style: 'tdtwo' },
              { text: item.scale, style: 'tdtwo' },
              { text: item.year_of_passing, style: 'tdtwo' },
              { text: item.duration, style: 'tdtwo' },
              { text: item.achievement, style: 'tdtwo' }
          ])
        })
        pdfContent.push({
          table: {
            headerRows: 1,
            widths: ['8.9%', '8.9%', '8.9%', '8.9%', '8.9%', '8.9%', '8.9%', '8.9%', '8.9%', '8.9%', '8.9%', '8.9%'],
            body: topRowsDataTwo
          }
        })
        pdfContent.push(
          {
            style: 'tableExample',
            table: {
              body: [
                [{ text: vm.$t('externalUser.present_address'), style: 'tableHeader', fillColor: '#dddddd', decoration: 'underline' }, { text: ':', fillColor: '#dddddd' }]
              ]
            },
            layout: 'noBorders'
          }
        )
        if (data.pm_upazilaText === undefined) {
          data.pm_upazilaText = ''
        }
        if (data.pm_divisionText === undefined) {
          data.pm_divisionText = ''
        }
        if (data.pm_wardText === undefined) {
          data.pm_wardText = ''
        }
        if (data.personal.pm_post_code === undefined) {
          data.personal.pm_post_code = ''
        }
        if (data.personal.pm_address_en === undefined) {
          data.personal.pm_address_en = ''
        }
        if (data.pm_districtText === undefined) {
          data.pm_districtText = ''
        }
        if (data.pr_districtText === undefined) {
          data.pr_districtText = ''
        }
        if (data.pr_upazilaText === undefined) {
          data.pr_upazilaText = ''
        }
        if (data.pr_divisionText === undefined) {
          data.pr_divisionText = ''
        }
        if (data.pr_wardText === undefined) {
          data.pr_wardText = ''
        }
        if (data.personal.pr_post_code === undefined) {
          data.personal.pr_post_code = ''
        }
        if (data.personal.pr_address_en === undefined) {
          data.personal.pr_address_en = ''
        }
        let addressBody = []
        if (data.personal.pm_area_type_id === 1) {
           addressBody = [
            [{ text: vm.$t('retailerManagement.division') + '                        :       ' + data.pm_divisionText }, { text: vm.$t('retailerManagement.district') + '          :       ' + data.pm_districtText }],
            [{ text: vm.$t('production_service_config.city_corporation_id') + '            :       ' + data.pm_cityCorporationText }, { text: vm.$t('org_pro.ward') + '          :       ' + data.pm_wardText }],
            [{ text: vm.$t('externalUser.present_address') + '             :       ' + data.personal.pm_address_en }, { text: '' }]
          ]
        }

        if (data.personal.pm_area_type_id === 2) {
          addressBody = [
            [{ text: vm.$t('retailerManagement.division') + '           :       ' + data.pm_divisionText }, { text: vm.$t('retailerManagement.district') + '                :       ' + data.pm_districtText }],
            [{ text: vm.$t('retailerManagement.upazilla') + '        :       ' + data.pm_upazilaText }, { text: vm.$t('org_pro.pauroshoba') + '            :       ' + data.pm_municipalityText }],
            [{ text: vm.$t('org_pro.ward') + '           :       ' + data.personal.pm_wardText }, { text: vm.$t('externalUser.present_address') + '     :       ' + data.personal.pm_address_en }]
          ]
         }

      if (data.personal.pm_area_type_id === 3) {
            addressBody = [
              [{ text: vm.$t('retailerManagement.division') + '           :       ' + data.pm_divisionText }, { text: vm.$t('retailerManagement.district') + '          :       ' + data.pm_districtText }],
              [{ text: vm.$t('retailerManagement.upazilla') + '        :       ' + data.pm_upazillaText }, { text: '' }],
              [{ text: '' }, { text: '' }]
            ]
         }
        pdfContent.push(
          {
            style: 'tableExample',
            table: {
              headerRows: 1,
              widths: ['50%', '50%'],
              body: addressBody
            },
            layout: 'noBorders'
          }
        )
        pdfContent.push(
          {
            style: 'tableExample',
            table: {
              body: [
                [{ text: vm.$t('externalUser.permanent_address'), style: 'tableHeader', fillColor: '#dddddd', decoration: 'underline' }, { text: ':', fillColor: '#dddddd' }]
              ]
            },
            layout: 'noBorders'
          }
        )
        let addressBodyTwo = []
        if (data.personal.pr_area_type_id === 1) {
           addressBodyTwo = [
            [{ text: vm.$t('retailerManagement.division') + '                        :       ' + data.pr_divisionText }, { text: vm.$t('retailerManagement.district') + '          :       ' + data.pr_districtText }],
            [{ text: vm.$t('production_service_config.city_corporation_id') + '            :       ' + data.pr_cityCorporationText }, { text: vm.$t('org_pro.ward') + '          :       ' + data.pr_wardText }],
            [{ text: vm.$t('externalUser.present_address') + '             :       ' + data.personal.pr_address_en }, { text: '' }]
          ]
        }

        if (data.personal.pr_area_type_id === 2) {
          addressBodyTwo = [
            [{ text: vm.$t('retailerManagement.division') + '           :       ' + data.pr_divisionText }, { text: vm.$t('retailerManagement.district') + '                :       ' + data.pr_districtText }],
            [{ text: vm.$t('retailerManagement.upazilla') + '        :       ' + data.pr_upazilaText }, { text: vm.$t('org_pro.pauroshoba') + '            :       ' + data.pr_municipalityText }],
            [{ text: vm.$t('org_pro.ward') + '           :       ' + data.pr_wardText }, { text: vm.$t('externalUser.present_address') + '     :       ' + data.personal.pr_address_en }]
          ]
        }

        if (data.personal.pr_area_type_id === 3) {
            addressBodyTwo = [
              [{ text: vm.$t('retailerManagement.division') + '           :       ' + data.pr_divisionText }, { text: vm.$t('retailerManagement.district') + '          :       ' + data.pr_districtText }],
              [{ text: vm.$t('retailerManagement.upazilla') + '                 :       ' + data.pr_upazilaText }, { text: '' }],
              [{ text: '' }, { text: '' }]
            ]
        }
        pdfContent.push(
          {
            style: 'tableExample',
            table: {
              headerRows: 1,
              widths: ['50%', '50%'],
              body: addressBodyTwo
            },
            layout: 'noBorders'
          }
        )
        var docDefinition = {
        content: pdfContent,
        pageSize: 'A4',
        pageOrientation: 'landscape',
        styles: {
            th: {
              fillColor: '#dee2e6',
              fontSize: 13,
              margin: [3, 3, 3, 3]
            },
            th1: {
                fontSize: 9
              },
            td: {
              fontSize: 10,
              margin: [0, 0, 0, 0]
            },
            tdtwo: {
              fontSize: 10,
              margin: [0, 0, 0, 0]
            },
            td2: {
                border: 0,
                fontSize: 13,
                alignment: 'center'
              },
            AddressTable: {
              margin: [0, 0, 250, 0]
            },
            header: {
              margin: [0, 10, 0, 10],
              fontSize: 17,
              alignment: 'center'
            },
            tableHeader: {
              fontSize: 11
            },
            header2: {
              border: 0,
              fontSize: 17,
              margin: [0, 0, 0, 1]
            },
            govt_info: {
              margin: [0, 1, 0, 1],
              fontSize: 18,
              alignment: 'center'
            },
            noborder: {
               border: 0
            },
            address: {
              border: 0,
              fontSize: 10,
              margin: [5, 0, 5, 5]
            },
            left_logo: {
              borderRadius: 50
            },
            mainName: {
              margin: [8, 0, 0, 20]
            },
            tableExample: {
              fontSize: 11,
              margin: [0, 10, 10, 10]
            }
          }
        }
        pdfMake.createPdf(docDefinition, null, null, null).print()
    } catch (error) {
      if (error) {}
    }
    Store.commit('mutateCommonProperties', {
      loading: false
    })
}
export default {
  exportPdfDetails
}
